export default __webpack_public_path__ + "static/video-8db5b9188ad6d76f5744c9d8f2f235d8.png";